export default {
    'action'     : 'Locations-MFEV2',
    'queryString': 'locatorCountry=US&locatorPostalCode=40509&locatorRadius=150&locatorUnit=mi',
    'locale'     : 'en_US',
    'locations'  : [
        {
            'id'              : 1462,
            'businessUnitCode': 'TM',
            'shiptoId'        : '588678',
            'selectFitEbsCode': {
                'id'  : 2,
                'name': 'CERT'
            },
            'selectFitCategory': {
                'id'  : 13,
                'name': 'GOLFTEC'
            },
            'selectFitLogoType': {
                'id'  : 3,
                'name': 'CERT'
            },
            'displayName'    : 'GOLFTEC BLUE ASH',
            'street'         : '11126 KENWOOD RD. STE. B',
            'city'           : 'Cincinnati',
            'state'          : 'OH',
            'postalCode'     : '45242',
            'countryCode'    : 'US',
            'onWebsite'      : true,
            'active'         : true,
            'latitude'       : 39.26787119999999,
            'longitude'      : -84.3720414,
            'geocodeAccuracy': 'ROOFTOP',
            'events'         : []
        },
        {
            'id'              : 1799,
            'businessUnitCode': 'TM',
            'shiptoId'        : '589009',
            'selectFitEbsCode': {
                'id'  : 3,
                'name': 'CORE'
            },
            'selectFitCategory': {
                'id'  : 15,
                'name': 'MINI'
            },
            'selectFitLogoType': {
                'id'  : 4,
                'name': 'CORE'
            },
            'displayName'    : 'The Patch at the Preserve',
            'street'         : '201 BROADBERRY AVE.',
            'city'           : 'Oak Ridge',
            'state'          : 'TN',
            'postalCode'     : '37830',
            'countryCode'    : 'US',
            'onWebsite'      : false,
            'active'         : true,
            'latitude'       : 35.9060526,
            'longitude'      : -84.4166247,
            'geocodeAccuracy': 'ROOFTOP',
            'events'         : []
        },
        {
            'id'              : 1796,
            'businessUnitCode': 'TM',
            'shiptoId'        : '585639',
            'selectFitEbsCode': {
                'id'  : 3,
                'name': 'CORE'
            },
            'selectFitCategory': {
                'id'  : 15,
                'name': 'MINI'
            },
            'selectFitLogoType': {
                'id'  : 4,
                'name': 'CORE'
            },
            'displayName'    : 'Centennial Golf Course',
            'street'         : '101 CENTINNIAL BLVD',
            'city'           : 'Oak Ridge',
            'state'          : 'TN',
            'postalCode'     : '37830',
            'countryCode'    : 'US',
            'onWebsite'      : false,
            'active'         : true,
            'latitude'       : 36.016472,
            'longitude'      : -84.17338219999999,
            'geocodeAccuracy': 'ROOFTOP',
            'events'         : []
        },
        {
            'id'              : 1641,
            'businessUnitCode': 'TM',
            'shiptoId'        : '519483',
            'selectFitEbsCode': {
                'id'  : 3,
                'name': 'CORE'
            },
            'selectFitCategory': {
                'id'  : 15,
                'name': 'MINI'
            },
            'selectFitLogoType': {
                'id'  : 4,
                'name': 'CORE'
            },
            'displayName'    : 'ORCHARD GOLF CENTER',
            'street'         : '251 N. STATE ROAD 135',
            'city'           : 'Greenwood',
            'state'          : 'IN',
            'postalCode'     : '46142',
            'countryCode'    : 'US',
            'onWebsite'      : false,
            'active'         : true,
            'latitude'       : 39.619377,
            'longitude'      : -86.15783979999999,
            'geocodeAccuracy': 'ROOFTOP',
            'events'         : []
        },
        {
            'id'              : 1640,
            'businessUnitCode': 'TM',
            'shiptoId'        : '553533',
            'selectFitEbsCode': {
                'id'  : 3,
                'name': 'CORE'
            },
            'selectFitCategory': {
                'id'  : 15,
                'name': 'MINI'
            },
            'selectFitLogoType': {
                'id'  : 4,
                'name': 'CORE'
            },
            'displayName'    : 'RICHMOND ELKS CC',
            'street'         : '2100 HIGHWAY 27 S',
            'city'           : 'Richmond',
            'state'          : 'IN',
            'postalCode'     : '47374',
            'countryCode'    : 'US',
            'onWebsite'      : false,
            'active'         : true,
            'latitude'       : 39.7984068,
            'longitude'      : -84.89381879999999,
            'geocodeAccuracy': 'ROOFTOP',
            'events'         : []
        },
        {
            'id'              : 1636,
            'businessUnitCode': 'TM',
            'shiptoId'        : '519934',
            'selectFitEbsCode': {
                'id'  : 3,
                'name': 'CORE'
            },
            'selectFitCategory': {
                'id'  : 15,
                'name': 'MINI'
            },
            'selectFitLogoType': {
                'id'  : 4,
                'name': 'CORE'
            },
            'displayName'    : 'FRENCH LICK RESORT',
            'street'         : '8670 W. STATE ROAD 56',
            'city'           : 'French Lick',
            'state'          : 'IN',
            'postalCode'     : '47432',
            'countryCode'    : 'US',
            'onWebsite'      : false,
            'active'         : true,
            'latitude'       : 38.5552784,
            'longitude'      : -86.62145369999999,
            'geocodeAccuracy': 'ROOFTOP',
            'events'         : []
        },
        {
            'id'              : 1531,
            'businessUnitCode': 'TM',
            'shiptoId'        : '551107',
            'selectFitEbsCode': {
                'id'  : 2,
                'name': 'CERT'
            },
            'selectFitCategory': {
                'id'  : 14,
                'name': 'WWG'
            },
            'selectFitLogoType': {
                'id'  : 3,
                'name': 'CERT'
            },
            'displayName'    : 'EDWIN WATTS LEXINGTON',
            'street'         : '3024 RICHMOND RD',
            'city'           : 'Lexington',
            'state'          : 'KY',
            'postalCode'     : '40509',
            'countryCode'    : 'US',
            'onWebsite'      : true,
            'bookingLink'    : false,
            'active'         : true,
            'latitude'       : 38.0042622,
            'longitude'      : -84.4510329,
            'geocodeAccuracy': 'ROOFTOP',
            'events'         : [
                {
                    'scheduledStart': '2025-02-28T10:00:00Z',
                    'scheduledEnd'  : '2025-02-28T14:00:00Z',
                    'location'      : {
                        'id'        : 2384,
                        'name'      : '102 LEX WATTS LEXINGTON',
                        'address1'  : '3024 RICHMOND RD',
                        'address2'  : 'EDI-102',
                        'address3'  : null,
                        'city'      : 'Lexington',
                        'postalCode': '40509',
                        'state'     : 'KY',
                        'shipTo'    : '551107',
                        'latitude'  : 38.0042622,
                        'longitude' : -84.4510329,
                        'country'   : 'US',
                        'accuracy'  : 'ROOFTOP',
                        'timeZoneId': 2
                    },
                    'shareLink': 'https://stage-myfittingexp.taylormadegolf.com/fitting/private/alLPzAq6MP'
                },
                {
                    'scheduledStart': '2025-02-28T11:00:00Z',
                    'scheduledEnd'  : '2025-02-28T15:00:00Z',
                    'location'      : {
                        'id'        : 2384,
                        'name'      : '102 LEX WATTS LEXINGTON',
                        'address1'  : '3024 RICHMOND RD',
                        'address2'  : 'EDI-102',
                        'address3'  : null,
                        'city'      : 'Lexington',
                        'postalCode': '40509',
                        'state'     : 'KY',
                        'shipTo'    : '551107',
                        'latitude'  : 38.0042622,
                        'longitude' : -84.4510329,
                        'country'   : 'US',
                        'accuracy'  : 'ROOFTOP',
                        'timeZoneId': 2
                    },
                    'shareLink': 'https://stage-myfittingexp.taylormadegolf.com/fitting/private/alLPzAq6MP'
                }
            ]
        },
        {
            'id'              : 1520,
            'businessUnitCode': 'TM',
            'shiptoId'        : '550539',
            'selectFitEbsCode': {
                'id'  : 2,
                'name': 'CERT'
            },
            'selectFitCategory': {
                'id'  : 14,
                'name': 'WWG'
            },
            'selectFitLogoType': {
                'id'  : 3,
                'name': 'CERT'
            },
            'displayName'    : 'EDWIN WATTS KNOXVILLE',
            'street'         : '11364 PARKSIDE DR',
            'city'           : 'Knoxville',
            'state'          : 'TN',
            'postalCode'     : '37934',
            'countryCode'    : 'US',
            'onWebsite'      : true,
            'bookingLink'    : 'https://stores.worldwidegolf.com',
            'active'         : true,
            'latitude'       : 35.8986657,
            'longitude'      : -84.1606189,
            'geocodeAccuracy': 'ROOFTOP',
            'events'         : []
        },
        {
            'id'              : 1463,
            'businessUnitCode': 'TM',
            'shiptoId'        : '588677',
            'selectFitEbsCode': {
                'id'  : 2,
                'name': 'CERT'
            },
            'selectFitCategory': {
                'id'  : 13,
                'name': 'GOLFTEC'
            },
            'selectFitLogoType': {
                'id'  : 3,
                'name': 'CERT'
            },
            'displayName'    : 'GOLFTEC LOUISVILLE',
            'street'         : '102 VIEUX CARRE DR.',
            'city'           : 'Louisville',
            'state'          : 'KY',
            'postalCode'     : '40223',
            'countryCode'    : 'US',
            'onWebsite'      : true,
            'active'         : true,
            'latitude'       : 38.2455321,
            'longitude'      : -85.5749986,
            'geocodeAccuracy': 'ROOFTOP',
            'events'         : []
        },
        {
            'id'              : 1820,
            'businessUnitCode': 'TM',
            'shiptoId'        : '551474',
            'selectFitEbsCode': {
                'id'  : 3,
                'name': 'RETAILER'
            },
            'selectFitCategory': {
                'id'  : 15,
                'name': 'MINI'
            },
            'selectFitLogoType': {
                'id'  : 4,
                'name': 'CORE'
            },
            'displayName'    : 'World of Golf',
            'street'         : '7400 WOODSPOINT DR',
            'city'           : 'Florence',
            'state'          : 'KY',
            'postalCode'     : '41042',
            'countryCode'    : 'US',
            'onWebsite'      : false,
            'active'         : true,
            'latitude'       : 39.0077164,
            'longitude'      : -84.6459505,
            'geocodeAccuracy': 'GEOMETRIC_CENTER',
            'events'         : []
        },
        {
            'id'              : 1230,
            'businessUnitCode': 'TM',
            'shiptoId'        : '590005',
            'selectFitEbsCode': {
                'id'  : 2,
                'name': 'CERT'
            },
            'selectFitCategory': {
                'id'  : 10,
                'name': 'DICK\'S CERT'
            },
            'selectFitLogoType': {
                'id'  : 3,
                'name': 'CERT'
            },
            'displayName'    : 'DICK\'S SPORTING GOODS',
            'street'         : '7675 WAREHOUSE ROW',
            'city'           : 'West Chester',
            'state'          : 'OH',
            'postalCode'     : '45069',
            'countryCode'    : 'US',
            'onWebsite'      : true,
            'active'         : true,
            'latitude'       : 39.372141,
            'longitude'      : -84.3691049,
            'geocodeAccuracy': 'ROOFTOP',
            'events'         : []
        },
        {
            'id'              : 1219,
            'businessUnitCode': 'TM',
            'shiptoId'        : '548364',
            'selectFitEbsCode': {
                'id'  : 2,
                'name': 'CERT'
            },
            'selectFitCategory': {
                'id'  : 10,
                'name': 'DICK\'S CERT'
            },
            'selectFitLogoType': {
                'id'  : 3,
                'name': 'CERT'
            },
            'displayName'    : 'DICK\'S SPORTING GOODS',
            'street'         : '469 RIVER HILL DR',
            'city'           : 'Ashland',
            'state'          : 'KY',
            'postalCode'     : '41101',
            'countryCode'    : 'US',
            'onWebsite'      : true,
            'active'         : true,
            'latitude'       : 38.4841347,
            'longitude'      : -82.6575431,
            'geocodeAccuracy': 'ROOFTOP',
            'events'         : []
        },
        {
            'id'              : 1147,
            'businessUnitCode': 'TM',
            'shiptoId'        : '521384',
            'selectFitEbsCode': {
                'id'  : 2,
                'name': 'CERT'
            },
            'selectFitCategory': {
                'id'  : 10,
                'name': 'DICK\'S CERT'
            },
            'selectFitLogoType': {
                'id'  : 3,
                'name': 'CERT'
            },
            'displayName'    : 'DICK\'S SPORTING GOODS',
            'street'         : '8220 OLD TROY PIKE',
            'city'           : 'Dayton',
            'state'          : 'OH',
            'postalCode'     : '45424',
            'countryCode'    : 'US',
            'onWebsite'      : true,
            'active'         : true,
            'latitude'       : 39.8742708,
            'longitude'      : -84.1335368,
            'geocodeAccuracy': 'ROOFTOP',
            'events'         : []
        },
        {
            'id'              : 1130,
            'businessUnitCode': 'TM',
            'shiptoId'        : '521280',
            'selectFitEbsCode': {
                'id'  : 2,
                'name': 'CERT'
            },
            'selectFitCategory': {
                'id'  : 10,
                'name': 'DICK\'S CERT'
            },
            'selectFitLogoType': {
                'id'  : 3,
                'name': 'CERT'
            },
            'displayName'    : 'DICK\'S SPORTING GOODS',
            'street'         : '951 E LEWIS & CLARK PARKWAY',
            'city'           : 'Clarksville',
            'state'          : 'IN',
            'postalCode'     : '47129',
            'countryCode'    : 'US',
            'onWebsite'      : true,
            'active'         : true,
            'latitude'       : 38.3195894,
            'longitude'      : -85.7607646,
            'geocodeAccuracy': 'ROOFTOP',
            'events'         : []
        },
        {
            'id'              : 1128,
            'businessUnitCode': 'TM',
            'shiptoId'        : '521278',
            'selectFitEbsCode': {
                'id'  : 2,
                'name': 'CERT'
            },
            'selectFitCategory': {
                'id'  : 10,
                'name': 'DICK\'S CERT'
            },
            'selectFitLogoType': {
                'id'  : 3,
                'name': 'CERT'
            },
            'displayName'    : 'DICK\'S SPORTING GOODS',
            'street'         : '2727 FAIRFIELD COMMONS BLVD.',
            'city'           : 'Dayton',
            'state'          : 'OH',
            'postalCode'     : '45431',
            'countryCode'    : 'US',
            'onWebsite'      : true,
            'active'         : true,
            'latitude'       : 39.7673771,
            'longitude'      : -84.0567172,
            'geocodeAccuracy': 'ROOFTOP',
            'events'         : []
        },
        {
            'id'              : 1115,
            'businessUnitCode': 'TM',
            'shiptoId'        : '521226',
            'selectFitEbsCode': {
                'id'  : 2,
                'name': 'CERT'
            },
            'selectFitCategory': {
                'id'  : 10,
                'name': 'DICK\'S CERT'
            },
            'selectFitLogoType': {
                'id'  : 3,
                'name': 'CERT'
            },
            'displayName'    : 'DICK\'S SPORTING GOODS',
            'street'         : '2850 E. 3RD STREET',
            'city'           : 'Bloomington',
            'state'          : 'IN',
            'postalCode'     : '47401',
            'countryCode'    : 'US',
            'onWebsite'      : true,
            'active'         : true,
            'latitude'       : 39.1605143,
            'longitude'      : -86.4957063,
            'geocodeAccuracy': 'ROOFTOP',
            'events'         : []
        },
        {
            'id'              : 1095,
            'businessUnitCode': 'TM',
            'shiptoId'        : '521173',
            'selectFitEbsCode': {
                'id'  : 2,
                'name': 'CERT'
            },
            'selectFitCategory': {
                'id'  : 10,
                'name': 'DICK\'S CERT'
            },
            'selectFitLogoType': {
                'id'  : 3,
                'name': 'CERT'
            },
            'displayName'    : 'DICK\'S SPORTING GOODS',
            'street'         : '5700 DEERFIELD BLVD',
            'city'           : 'Mason',
            'state'          : 'OH',
            'postalCode'     : '45040',
            'countryCode'    : 'US',
            'onWebsite'      : true,
            'active'         : true,
            'latitude'       : 39.3087613,
            'longitude'      : -84.31681239999999,
            'geocodeAccuracy': 'ROOFTOP',
            'events'         : []
        },
        {
            'id'              : 1082,
            'businessUnitCode': 'TM',
            'shiptoId'        : '521071',
            'selectFitEbsCode': {
                'id'  : 2,
                'name': 'CERT'
            },
            'selectFitCategory': {
                'id'  : 10,
                'name': 'DICK\'S CERT'
            },
            'selectFitLogoType': {
                'id'  : 3,
                'name': 'CERT'
            },
            'displayName'    : 'DICK\'S SPORTING GOODS',
            'street'         : '650 EASTGATE SOUTH DRIVE',
            'city'           : 'Cincinnati',
            'state'          : 'OH',
            'postalCode'     : '45245',
            'countryCode'    : 'US',
            'onWebsite'      : true,
            'active'         : true,
            'latitude'       : 39.0976077,
            'longitude'      : -84.27908819999999,
            'geocodeAccuracy': 'ROOFTOP',
            'events'         : []
        },
        {
            'id'              : 2068,
            'businessUnitCode': 'TM',
            'shiptoId'        : '548518',
            'selectFitEbsCode': {
                'id'  : 3,
                'name': 'CORE'
            },
            'selectFitCategory': {
                'id'  : 16,
                'name': 'DICK\'S MINI'
            },
            'selectFitLogoType': {
                'id'  : 4,
                'name': 'CORE'
            },
            'displayName'    : 'DICK\'S SPORTING GOODS',
            'street'         : 'NEWPORT PAVILION',
            'city'           : 'Newport',
            'state'          : 'KY',
            'postalCode'     : '41071',
            'countryCode'    : 'US',
            'onWebsite'      : true,
            'active'         : true,
            'latitude'       : 39.0881816,
            'longitude'      : -84.47666389999999,
            'geocodeAccuracy': 'ROOFTOP',
            'events'         : []
        },
        {
            'id'              : 2214,
            'businessUnitCode': 'TM',
            'shiptoId'        : '553848',
            'selectFitEbsCode': {
                'id'  : 3,
                'name': 'CORE'
            },
            'selectFitCategory': {
                'id'  : 16,
                'name': 'DICK\'S MINI'
            },
            'selectFitLogoType': {
                'id'  : 4,
                'name': 'CORE'
            },
            'displayName'    : 'DICK\'S SPORTING GOODS',
            'street'         : '10180 COLERAIN AVE',
            'city'           : 'Cincinnati',
            'state'          : 'OH',
            'postalCode'     : '45251',
            'countryCode'    : 'US',
            'onWebsite'      : true,
            'active'         : true,
            'latitude'       : 39.2614987,
            'longitude'      : -84.6013516,
            'geocodeAccuracy': 'ROOFTOP',
            'events'         : []
        },
        {
            'id'              : 2138,
            'businessUnitCode': 'TM',
            'shiptoId'        : '554419',
            'selectFitEbsCode': {
                'id'  : 3,
                'name': 'CORE'
            },
            'selectFitCategory': {
                'id'  : 16,
                'name': 'DICK\'S MINI'
            },
            'selectFitLogoType': {
                'id'  : 4,
                'name': 'CORE'
            },
            'displayName'    : 'DICK\'S SPORTING GOODS',
            'street'         : '2550 E MORRIS BLVD',
            'city'           : 'Morristown',
            'state'          : 'TN',
            'postalCode'     : '37813',
            'countryCode'    : 'US',
            'onWebsite'      : true,
            'active'         : true,
            'latitude'       : 36.2205154,
            'longitude'      : -83.26309390000002,
            'geocodeAccuracy': 'ROOFTOP',
            'events'         : []
        },
        {
            'id'              : 2131,
            'businessUnitCode': 'TM',
            'shiptoId'        : '590007',
            'selectFitEbsCode': {
                'id'  : 3,
                'name': 'CORE'
            },
            'selectFitCategory': {
                'id'  : 16,
                'name': 'DICK\'S MINI'
            },
            'selectFitLogoType': {
                'id'  : 4,
                'name': 'CORE'
            },
            'displayName'    : 'DICK\'S SPORTING GOODS',
            'street'         : '7800 MONTGOMERY RD UNIT 275',
            'city'           : 'Cincinnati',
            'state'          : 'OH',
            'postalCode'     : '45236',
            'countryCode'    : 'US',
            'onWebsite'      : true,
            'active'         : true,
            'latitude'       : 39.1977347,
            'longitude'      : -84.37802520000001,
            'geocodeAccuracy': 'ROOFTOP',
            'events'         : []
        },
        {
            'id'              : 2109,
            'businessUnitCode': 'TM',
            'shiptoId'        : '554896',
            'selectFitEbsCode': {
                'id'  : 3,
                'name': 'CORE'
            },
            'selectFitCategory': {
                'id'  : 16,
                'name': 'DICK\'S MINI'
            },
            'selectFitLogoType': {
                'id'  : 4,
                'name': 'CORE'
            },
            'displayName'    : 'DICK\'S SPORTING GOODS',
            'street'         : '369 S. ILLINOIS AVE',
            'city'           : 'Oak Ridge',
            'state'          : 'TN',
            'postalCode'     : '37830',
            'countryCode'    : 'US',
            'onWebsite'      : true,
            'active'         : true,
            'latitude'       : 36.0089124,
            'longitude'      : -84.2550425,
            'geocodeAccuracy': 'ROOFTOP',
            'events'         : []
        },
        {
            'id'              : 2105,
            'businessUnitCode': 'TM',
            'shiptoId'        : '552817',
            'selectFitEbsCode': {
                'id'  : 3,
                'name': 'CORE'
            },
            'selectFitCategory': {
                'id'  : 16,
                'name': 'DICK\'S MINI'
            },
            'selectFitLogoType': {
                'id'  : 4,
                'name': 'CORE'
            },
            'displayName'    : 'DICK\'S SPORTING GOODS',
            'street'         : 'GUERNSEY CROSSING',
            'city'           : 'Chillicothe',
            'state'          : 'OH',
            'postalCode'     : '45601',
            'countryCode'    : 'US',
            'onWebsite'      : true,
            'active'         : true,
            'latitude'       : 39.3623092,
            'longitude'      : -82.9752094,
            'geocodeAccuracy': 'ROOFTOP',
            'events'         : []
        },
        {
            'id'              : 2089,
            'businessUnitCode': 'TM',
            'shiptoId'        : '551805',
            'selectFitEbsCode': {
                'id'  : 3,
                'name': 'CORE'
            },
            'selectFitCategory': {
                'id'  : 16,
                'name': 'DICK\'S MINI'
            },
            'selectFitLogoType': {
                'id'  : 4,
                'name': 'CORE'
            },
            'displayName'    : 'DICK\'S SPORTING GOODS',
            'street'         : '2145 LANTERN RIDGE DR',
            'city'           : 'Richmond',
            'state'          : 'KY',
            'postalCode'     : '40475',
            'countryCode'    : 'US',
            'onWebsite'      : true,
            'active'         : true,
            'latitude'       : 37.7384349,
            'longitude'      : -84.3262517,
            'geocodeAccuracy': 'ROOFTOP',
            'events'         : []
        },
        {
            'id'              : 2088,
            'businessUnitCode': 'TM',
            'shiptoId'        : '551804',
            'selectFitEbsCode': {
                'id'  : 3,
                'name': 'CORE'
            },
            'selectFitCategory': {
                'id'  : 16,
                'name': 'DICK\'S MINI'
            },
            'selectFitLogoType': {
                'id'  : 4,
                'name': 'CORE'
            },
            'displayName'    : 'DICK\'S SPORTING GOODS',
            'street'         : '3718 NATIONAL RD EAST',
            'city'           : 'Richmond',
            'state'          : 'IN',
            'postalCode'     : '47374',
            'countryCode'    : 'US',
            'onWebsite'      : true,
            'active'         : true,
            'latitude'       : 39.8331569,
            'longitude'      : -84.8500309,
            'geocodeAccuracy': 'ROOFTOP',
            'events'         : []
        },
        {
            'id'              : 2072,
            'businessUnitCode': 'TM',
            'shiptoId'        : '551622',
            'selectFitEbsCode': {
                'id'  : 3,
                'name': 'CORE'
            },
            'selectFitCategory': {
                'id'  : 16,
                'name': 'DICK\'S MINI'
            },
            'selectFitLogoType': {
                'id'  : 4,
                'name': 'CORE'
            },
            'displayName'    : 'DICK\'S SPORTING GOODS',
            'street'         : '7800 JOHN DAVIS DRIVE, STE 100',
            'city'           : 'Frankfort',
            'state'          : 'KY',
            'postalCode'     : '40601',
            'countryCode'    : 'US',
            'onWebsite'      : true,
            'active'         : true,
            'latitude'       : 38.1756904,
            'longitude'      : -84.8207017,
            'geocodeAccuracy': 'ROOFTOP',
            'events'         : []
        },
        {
            'id'               : 939,
            'businessUnitCode' : 'TM',
            'shiptoId'         : '552383',
            'selectFitLogoType': {
                'id'  : 3,
                'name': 'CERT'
            },
            'displayName'    : 'Golf Exchange West Chester',
            'street'         : '7610 COX RD',
            'city'           : 'West Chester',
            'state'          : 'OH',
            'postalCode'     : '45069',
            'countryCode'    : 'US',
            'onWebsite'      : true,
            'active'         : true,
            'latitude'       : 39.356053,
            'longitude'      : -84.3643688,
            'geocodeAccuracy': 'RANGE_INTERPOLATED',
            'events'         : []
        },
        {
            'id'              : 2037,
            'businessUnitCode': 'TM',
            'shiptoId'        : '547260',
            'selectFitEbsCode': {
                'id'  : 3,
                'name': 'CORE'
            },
            'selectFitCategory': {
                'id'  : 16,
                'name': 'DICK\'S MINI'
            },
            'selectFitLogoType': {
                'id'  : 4,
                'name': 'CORE'
            },
            'displayName'    : 'DICK\'S SPORTING GOODS',
            'street'         : '2700 MIAISBURG CENTERVILLE RD',
            'city'           : 'Dayton',
            'state'          : 'OH',
            'postalCode'     : '45459',
            'countryCode'    : 'US',
            'onWebsite'      : true,
            'active'         : true,
            'latitude'       : 39.6336819,
            'longitude'      : -84.2209634,
            'geocodeAccuracy': 'ROOFTOP',
            'events'         : []
        },
        {
            'id'              : 1948,
            'businessUnitCode': 'TM',
            'shiptoId'        : '521291',
            'selectFitEbsCode': {
                'id'  : 3,
                'name': 'CORE'
            },
            'selectFitCategory': {
                'id'  : 16,
                'name': 'DICK\'S MINI'
            },
            'selectFitLogoType': {
                'id'  : 4,
                'name': 'CORE'
            },
            'displayName'    : 'DICK\'S SPORTING GOODS',
            'street'         : '1656 STRINGTOWN RD',
            'city'           : 'Grove City',
            'state'          : 'OH',
            'postalCode'     : '43123',
            'countryCode'    : 'US',
            'onWebsite'      : true,
            'active'         : true,
            'latitude'       : 39.8798357,
            'longitude'      : -83.03781579999999,
            'geocodeAccuracy': 'GEOMETRIC_CENTER',
            'events'         : []
        },
        {
            'id'              : 1940,
            'businessUnitCode': 'TM',
            'shiptoId'        : '521241',
            'selectFitEbsCode': {
                'id'  : 3,
                'name': 'CORE'
            },
            'selectFitCategory': {
                'id'  : 16,
                'name': 'DICK\'S MINI'
            },
            'selectFitLogoType': {
                'id'  : 4,
                'name': 'CORE'
            },
            'displayName'    : 'DICK\'S SPORTING GOODS',
            'street'         : '3355 PRINCETON RD',
            'city'           : 'Hamilton',
            'state'          : 'OH',
            'postalCode'     : '45011',
            'countryCode'    : 'US',
            'onWebsite'      : true,
            'active'         : true,
            'latitude'       : 39.3897318,
            'longitude'      : -84.504497,
            'geocodeAccuracy': 'RANGE_INTERPOLATED',
            'events'         : []
        },
        {
            'id'              : 1903,
            'businessUnitCode': 'TM',
            'shiptoId'        : '521074',
            'selectFitEbsCode': {
                'id'  : 3,
                'name': 'CORE'
            },
            'selectFitCategory': {
                'id'  : 16,
                'name': 'DICK\'S MINI'
            },
            'selectFitLogoType': {
                'id'  : 4,
                'name': 'CORE'
            },
            'displayName'    : 'DICK\'S SPORTING GOODS',
            'street'         : '5555 GLENWAY AVE.',
            'city'           : 'Cincinnati',
            'state'          : 'OH',
            'postalCode'     : '45238',
            'countryCode'    : 'US',
            'onWebsite'      : true,
            'active'         : true,
            'latitude'       : 39.14100070000001,
            'longitude'      : -84.618456,
            'geocodeAccuracy': 'ROOFTOP',
            'events'         : []
        },
        {
            'id'              : 1900,
            'businessUnitCode': 'TM',
            'shiptoId'        : '521019',
            'selectFitEbsCode': {
                'id'  : 3,
                'name': 'CORE'
            },
            'selectFitCategory': {
                'id'  : 16,
                'name': 'DICK\'S MINI'
            },
            'selectFitLogoType': {
                'id'  : 4,
                'name': 'CORE'
            },
            'displayName'    : 'DICK\'S SPORTING GOODS',
            'street'         : '3500 HURSTBOURNE PARKWAY',
            'city'           : 'Louisville',
            'state'          : 'KY',
            'postalCode'     : '40299',
            'countryCode'    : 'US',
            'onWebsite'      : true,
            'active'         : true,
            'latitude'       : 38.1981334,
            'longitude'      : -85.60477470000001,
            'geocodeAccuracy': 'ROOFTOP',
            'events'         : []
        },
        {
            'id'              : 1822,
            'businessUnitCode': 'TM',
            'shiptoId'        : '554645',
            'selectFitEbsCode': {
                'id'  : 3,
                'name': 'CORE'
            },
            'selectFitCategory': {
                'id'  : 15,
                'name': 'MINI'
            },
            'selectFitLogoType': {
                'id'  : 4,
                'name': 'CORE'
            },
            'displayName'    : 'Nevel Meade Golf Club',
            'street'         : '3123 NEVEL MEADE DR',
            'city'           : 'Prospect',
            'state'          : 'KY',
            'postalCode'     : '40059',
            'countryCode'    : 'US',
            'onWebsite'      : false,
            'active'         : true,
            'latitude'       : 38.3779256,
            'longitude'      : -85.5593129,
            'geocodeAccuracy': 'ROOFTOP',
            'events'         : []
        },
        {
            'id'              : 1821,
            'businessUnitCode': 'TM',
            'shiptoId'        : '510444',
            'selectFitEbsCode': {
                'id'  : 3,
                'name': 'CORE'
            },
            'selectFitCategory': {
                'id'  : 15,
                'name': 'MINI'
            },
            'selectFitLogoType': {
                'id'  : 4,
                'name': 'CORE'
            },
            'displayName'    : 'Covered Bridge Golf Course',
            'street'         : 'KSM INDIANA LLC',
            'city'           : 'Sellersburg',
            'state'          : 'IN',
            'postalCode'     : '47172',
            'countryCode'    : 'US',
            'onWebsite'      : false,
            'active'         : true,
            'latitude'       : 38.3981216,
            'longitude'      : -85.754964,
            'geocodeAccuracy': 'APPROXIMATE',
            'events'         : []
        },
        {
            'id'              : 186,
            'businessUnitCode': 'TM',
            'shiptoId'        : '582618',
            'selectFitEbsCode': {
                'id'  : 1,
                'name': 'PREM'
            },
            'selectFitCategory': {
                'id'  : 4,
                'name': 'PREM6'
            },
            'selectFitLogoType': {
                'id'  : 1,
                'name': 'PREM'
            },
            'displayName'    : 'Club Champion',
            'street'         : '12919 SHELBYVILLE ROAD',
            'city'           : 'Louisville',
            'state'          : 'KY',
            'postalCode'     : '40243',
            'countryCode'    : 'US',
            'onWebsite'      : true,
            'active'         : true,
            'latitude'       : 38.2434671,
            'longitude'      : -85.5136126,
            'geocodeAccuracy': 'ROOFTOP',
            'events'         : []
        },
        {
            'id'              : 475,
            'businessUnitCode': 'TM',
            'shiptoId'        : '521181',
            'selectFitEbsCode': {
                'id'  : 1,
                'name': 'PREM'
            },
            'selectFitCategory': {
                'id'  : 7,
                'name': 'DICK\'S PREM'
            },
            'selectFitLogoType': {
                'id'  : 1,
                'name': 'PREM'
            },
            'displayName'    : 'DICK\'S SPORTING GOODS',
            'street'         : '1251 US 31 NORTH',
            'city'           : 'Greenwood',
            'state'          : 'IN',
            'postalCode'     : '46142',
            'countryCode'    : 'US',
            'onWebsite'      : true,
            'active'         : true,
            'latitude'       : 39.6330413,
            'longitude'      : -86.1235722,
            'geocodeAccuracy': 'ROOFTOP',
            'events'         : []
        },
        {
            'id'              : 462,
            'businessUnitCode': 'TM',
            'shiptoId'        : '521026',
            'selectFitEbsCode': {
                'id'  : 1,
                'name': 'PREM'
            },
            'selectFitCategory': {
                'id'  : 7,
                'name': 'DICK\'S PREM'
            },
            'selectFitLogoType': {
                'id'  : 1,
                'name': 'PREM'
            },
            'displayName'    : 'DICK\'S SPORTING GOODS',
            'street'         : '1968 PAVILLION WAY',
            'city'           : 'Lexington',
            'state'          : 'KY',
            'postalCode'     : '40509',
            'countryCode'    : 'US',
            'onWebsite'      : true,
            'active'         : true,
            'latitude'       : 38.0241422,
            'longitude'      : -84.4157893,
            'geocodeAccuracy': 'ROOFTOP',
            'events'         : []
        },
        {
            'id'              : 445,
            'businessUnitCode': 'TM',
            'shiptoId'        : '588137',
            'selectFitEbsCode': {
                'id'  : 1,
                'name': 'PREM'
            },
            'selectFitCategory': {
                'id'  : 6,
                'name': 'GOLF GALAXY'
            },
            'selectFitLogoType': {
                'id'  : 1,
                'name': 'PREM'
            },
            'displayName'    : 'GOLF GALAXY',
            'street'         : '7600 KINGSTON PIKE, STE. 400',
            'city'           : 'Knoxville',
            'state'          : 'TN',
            'postalCode'     : '37919',
            'countryCode'    : 'US',
            'onWebsite'      : true,
            'active'         : true,
            'latitude'       : 35.9244489,
            'longitude'      : -84.03871529999999,
            'geocodeAccuracy': 'ROOFTOP',
            'events'         : []
        },
        {
            'id'              : 402,
            'businessUnitCode': 'TM',
            'shiptoId'        : '544881',
            'selectFitEbsCode': {
                'id'  : 1,
                'name': 'PREM'
            },
            'selectFitCategory': {
                'id'  : 6,
                'name': 'GOLF GALAXY'
            },
            'selectFitLogoType': {
                'id'  : 1,
                'name': 'PREM'
            },
            'displayName'    : 'GOLF GALAXY',
            'street'         : '5071 SHELBYVILLE ROAD',
            'city'           : 'Louisville',
            'state'          : 'KY',
            'postalCode'     : '40207',
            'countryCode'    : 'US',
            'onWebsite'      : true,
            'bookingLink'    : 'https://www.golfgalaxy.com/s/louisville-store-scheduling',
            'active'         : true,
            'latitude'       : 38.2517096,
            'longitude'      : -85.62136339999999,
            'geocodeAccuracy': 'ROOFTOP',
            'events'         : []
        },
        {
            'id'              : 370,
            'businessUnitCode': 'TM',
            'shiptoId'        : '542059',
            'selectFitEbsCode': {
                'id'  : 1,
                'name': 'PREM'
            },
            'selectFitCategory': {
                'id'  : 6,
                'name': 'GOLF GALAXY'
            },
            'selectFitLogoType': {
                'id'  : 1,
                'name': 'PREM'
            },
            'displayName'    : 'GOLF GALAXY',
            'street'         : '11825 COMMONS DRIVE',
            'city'           : 'Cincinnati',
            'state'          : 'OH',
            'postalCode'     : '45246',
            'countryCode'    : 'US',
            'onWebsite'      : true,
            'bookingLink'    : 'https://www.golfgalaxy.com/s/springdale-store-scheduling',
            'active'         : true,
            'latitude'       : 39.2916946,
            'longitude'      : -84.458491,
            'geocodeAccuracy': 'ROOFTOP',
            'events'         : []
        },
        {
            'id'              : 368,
            'businessUnitCode': 'TM',
            'shiptoId'        : '542055',
            'selectFitEbsCode': {
                'id'  : 1,
                'name': 'PREM'
            },
            'selectFitCategory': {
                'id'  : 6,
                'name': 'GOLF GALAXY'
            },
            'selectFitLogoType': {
                'id'  : 1,
                'name': 'PREM'
            },
            'displayName'    : 'GOLF GALAXY',
            'street'         : '8115 SPRINGBORO PIKE',
            'city'           : 'Miamisburg',
            'state'          : 'OH',
            'postalCode'     : '45342',
            'countryCode'    : 'US',
            'onWebsite'      : true,
            'bookingLink'    : 'https://www.golfgalaxy.com/s/miamisburg-store-scheduling',
            'active'         : true,
            'latitude'       : 39.6332488,
            'longitude'      : -84.2268093,
            'geocodeAccuracy': 'ROOFTOP',
            'events'         : []
        },
        {
            'id'              : 232,
            'businessUnitCode': 'TM',
            'shiptoId'        : '589529',
            'selectFitEbsCode': {
                'id'  : 1,
                'name': 'PREM'
            },
            'selectFitCategory': {
                'id'  : 4,
                'name': 'PREM6'
            },
            'selectFitLogoType': {
                'id'  : 1,
                'name': 'PREM'
            },
            'displayName'    : 'Club Champion',
            'street'         : '11651 PARKSIDE DR.',
            'city'           : 'Knoxville',
            'state'          : 'TN',
            'postalCode'     : '37934',
            'countryCode'    : 'US',
            'onWebsite'      : true,
            'active'         : true,
            'latitude'       : 35.89593170000001,
            'longitude'      : -84.1714611,
            'geocodeAccuracy': 'ROOFTOP',
            'events'         : []
        },
        {
            'id'              : 216,
            'businessUnitCode': 'TM',
            'shiptoId'        : '582190',
            'selectFitEbsCode': {
                'id'  : 1,
                'name': 'PREM'
            },
            'selectFitCategory': {
                'id'  : 4,
                'name': 'PREM6'
            },
            'selectFitLogoType': {
                'id'  : 1,
                'name': 'PREM'
            },
            'displayName'    : 'Club Champion',
            'street'         : '7714 Montgomery',
            'city'           : 'Cincinnati',
            'state'          : 'OH',
            'postalCode'     : '45236',
            'countryCode'    : 'US',
            'onWebsite'      : true,
            'active'         : true,
            'latitude'       : 39.1959098,
            'longitude'      : -84.3849438,
            'geocodeAccuracy': 'ROOFTOP',
            'events'         : []
        },
        {
            'id'              : 476,
            'businessUnitCode': 'TM',
            'shiptoId'        : '521187',
            'selectFitEbsCode': {
                'id'  : 1,
                'name': 'PREM'
            },
            'selectFitCategory': {
                'id'  : 7,
                'name': 'DICK\'S PREM'
            },
            'selectFitLogoType': {
                'id'  : 1,
                'name': 'PREM'
            },
            'displayName'    : 'DICK\'S SPORTING GOODS',
            'street'         : '3645 NICHOLASVILLE RD',
            'city'           : 'Lexington',
            'state'          : 'KY',
            'postalCode'     : '40503',
            'countryCode'    : 'US',
            'onWebsite'      : true,
            'active'         : true,
            'latitude'       : 37.98703940000001,
            'longitude'      : -84.53016459999999,
            'geocodeAccuracy': 'ROOFTOP',
            'events'         : []
        },
        {
            'id'              : 109,
            'businessUnitCode': 'TM',
            'shiptoId'        : '514249',
            'selectFitEbsCode': {
                'id'  : 1,
                'name': 'PREM'
            },
            'selectFitCategory': {
                'id'  : 3,
                'name': 'NFC'
            },
            'selectFitLogoType': {
                'id'  : 2,
                'name': 'NFC'
            },
            'displayName'    : 'THE GOLF EXCHANGE INC',
            'street'         : '7729 MALL ROAD',
            'city'           : 'Florence',
            'state'          : 'KY',
            'postalCode'     : '41042',
            'countryCode'    : 'US',
            'onWebsite'      : true,
            'active'         : true,
            'latitude'       : 38.9950451,
            'longitude'      : -84.6558,
            'geocodeAccuracy': 'ROOFTOP',
            'events'         : []
        },
        {
            'id'              : 97,
            'businessUnitCode': 'TM',
            'shiptoId'        : '511619',
            'selectFitEbsCode': {
                'id'  : 1,
                'name': 'PREM'
            },
            'selectFitCategory': {
                'id'  : 3,
                'name': 'NFC'
            },
            'selectFitLogoType': {
                'id'  : 2,
                'name': 'NFC'
            },
            'displayName'    : 'FAIRWAYS AND GREENS, INC.',
            'street'         : '626 SIMMONS RD.',
            'city'           : 'Knoxville',
            'state'          : 'TN',
            'postalCode'     : '37932',
            'countryCode'    : 'US',
            'onWebsite'      : true,
            'active'         : true,
            'latitude'       : 35.9140167,
            'longitude'      : -84.1382986,
            'geocodeAccuracy': 'ROOFTOP',
            'events'         : []
        },
        {
            'id'              : 57,
            'businessUnitCode': 'TM',
            'shiptoId'        : '513340',
            'selectFitEbsCode': {
                'id'  : 1,
                'name': 'PREM'
            },
            'selectFitCategory': {
                'id'  : 2,
                'name': 'PREM'
            },
            'selectFitLogoType': {
                'id'  : 1,
                'name': 'PREM'
            },
            'displayName'    : 'Golf Headquarters Louisville',
            'street'         : '13110 SHELBYVILLE ROAD',
            'city'           : 'Louisville',
            'state'          : 'KY',
            'postalCode'     : '40243',
            'countryCode'    : 'US',
            'onWebsite'      : true,
            'active'         : true,
            'latitude'       : 38.2422657,
            'longitude'      : -85.51268259999999,
            'geocodeAccuracy': 'ROOFTOP',
            'events'         : []
        },
        {
            'id'              : 56,
            'businessUnitCode': 'TM',
            'shiptoId'        : '548626',
            'selectFitEbsCode': {
                'id'  : 1,
                'name': 'PREM'
            },
            'selectFitCategory': {
                'id'  : 2,
                'name': 'PREM'
            },
            'selectFitLogoType': {
                'id'  : 1,
                'name': 'PREM'
            },
            'displayName'    : 'Miles of Golf Cincinnati',
            'street'         : '6400 DIXIE HWY',
            'city'           : 'Fairfield',
            'state'          : 'OH',
            'postalCode'     : '45014',
            'countryCode'    : 'US',
            'onWebsite'      : true,
            'active'         : true,
            'latitude'       : 39.3234893,
            'longitude'      : -84.50354829999999,
            'geocodeAccuracy': 'ROOFTOP',
            'events'         : []
        },
        {
            'id'              : 55,
            'businessUnitCode': 'TM',
            'shiptoId'        : '547154',
            'selectFitEbsCode': {
                'id'  : 1,
                'name': 'PREM'
            },
            'selectFitCategory': {
                'id'  : 2,
                'name': 'PREM'
            },
            'selectFitLogoType': {
                'id'  : 1,
                'name': 'PREM'
            },
            'displayName'    : 'Golf Exchange Kenwood',
            'street'         : '8118 MONTGOMERY RD',
            'city'           : 'Cincinnati',
            'state'          : 'OH',
            'postalCode'     : '45236',
            'countryCode'    : 'US',
            'onWebsite'      : true,
            'active'         : true,
            'latitude'       : 39.2035644,
            'longitude'      : -84.36878569999999,
            'geocodeAccuracy': 'ROOFTOP',
            'events'         : []
        },
        {
            'id'              : 54,
            'businessUnitCode': 'TM',
            'shiptoId'        : '551828',
            'selectFitEbsCode': {
                'id'  : 1,
                'name': 'PREM'
            },
            'selectFitCategory': {
                'id'  : 2,
                'name': 'PREM'
            },
            'selectFitLogoType': {
                'id'  : 1,
                'name': 'PREM'
            },
            'displayName'    : 'Golf Exchange Eastgate',
            'street'         : '4450 EASTGATE BLVD SUITE 290',
            'city'           : 'Cincinnati',
            'state'          : 'OH',
            'postalCode'     : '45245',
            'countryCode'    : 'US',
            'onWebsite'      : true,
            'active'         : true,
            'latitude'       : 39.0936735,
            'longitude'      : -84.2715106,
            'geocodeAccuracy': 'ROOFTOP',
            'events'         : []
        },
        {
            'id'              : 53,
            'businessUnitCode': 'TM',
            'shiptoId'        : '555974',
            'selectFitEbsCode': {
                'id'  : 1,
                'name': 'PREM'
            },
            'selectFitCategory': {
                'id'  : 2,
                'name': 'PREM'
            },
            'selectFitLogoType': {
                'id'  : 1,
                'name': 'PREM'
            },
            'displayName'    : 'Golf Exchange Lexington',
            'street'         : '3069 RICHMOND RD.',
            'city'           : 'Lexington',
            'state'          : 'KY',
            'postalCode'     : '40509',
            'countryCode'    : 'US',
            'onWebsite'      : true,
            'active'         : true,
            'latitude'       : 38.0018386,
            'longitude'      : -84.4458806,
            'geocodeAccuracy': 'ROOFTOP',
            'events'         : []
        },
        {
            'id'               : 894,
            'businessUnitCode' : 'TM',
            'shiptoId'         : '543818',
            'selectFitLogoType': {
                'id'  : 3,
                'name': 'CERT'
            },
            'displayName'    : 'Golftec Knoxville',
            'street'         : '7240 KINGSTON PIKE SUITE 144',
            'city'           : 'Knoxville',
            'state'          : 'TN',
            'postalCode'     : '37919',
            'countryCode'    : 'US',
            'onWebsite'      : true,
            'active'         : true,
            'latitude'       : 35.9289272,
            'longitude'      : -84.0301763,
            'geocodeAccuracy': 'ROOFTOP',
            'events'         : []
        },
        {
            'id'               : 938,
            'businessUnitCode' : 'TM',
            'shiptoId'         : '507551',
            'selectFitLogoType': {
                'id'  : 3,
                'name': 'CERT'
            },
            'displayName'    : 'MAN O\'WAR GOLF',
            'street'         : '1201 MAN O\' WAR BLVD.',
            'city'           : 'Lexington',
            'state'          : 'KY',
            'postalCode'     : '40513',
            'countryCode'    : 'US',
            'onWebsite'      : true,
            'active'         : true,
            'latitude'       : 38.032439,
            'longitude'      : -84.58431209999999,
            'geocodeAccuracy': 'ROOFTOP',
            'events'         : []
        },
        {
            'id'               : 937,
            'businessUnitCode' : 'TM',
            'shiptoId'         : '588161',
            'selectFitLogoType': {
                'id'  : 3,
                'name': 'CERT'
            },
            'displayName'    : 'BLUEGRASS GOLF ACADEMY',
            'street'         : '4400 ATHENS BOONESBORO RD',
            'city'           : 'Lexington',
            'state'          : 'KY',
            'postalCode'     : '40509',
            'countryCode'    : 'US',
            'onWebsite'      : true,
            'active'         : true,
            'latitude'       : 37.9775181,
            'longitude'      : -84.4170504,
            'geocodeAccuracy': 'ROOFTOP',
            'events'         : []
        },
        {
            'id'               : 936,
            'businessUnitCode' : 'TM',
            'shiptoId'         : '514585',
            'selectFitLogoType': {
                'id'  : 3,
                'name': 'CERT'
            },
            'displayName'    : 'Southwest Golf Ranch',
            'street'         : '2880 SOUTH US ROUTE 42',
            'city'           : 'Lebanon',
            'state'          : 'OH',
            'postalCode'     : '45036',
            'countryCode'    : 'US',
            'onWebsite'      : true,
            'active'         : true,
            'latitude'       : 39.3943893,
            'longitude'      : -84.2615306,
            'geocodeAccuracy': 'ROOFTOP',
            'events'         : []
        },
        {
            'id'               : 935,
            'businessUnitCode' : 'TM',
            'shiptoId'         : '588235',
            'selectFitLogoType': {
                'id'  : 3,
                'name': 'CERT'
            },
            'displayName'    : '50 Yards Longer',
            'street'         : '11125 KENWOOD ROAD',
            'city'           : 'Cincinnati',
            'state'          : 'OH',
            'postalCode'     : '45242',
            'countryCode'    : 'US',
            'onWebsite'      : true,
            'active'         : true,
            'latitude'       : 39.2678718,
            'longitude'      : -84.3745108,
            'geocodeAccuracy': 'ROOFTOP',
            'events'         : []
        },
        {
            'id'               : 932,
            'businessUnitCode' : 'TM',
            'shiptoId'         : '554466',
            'selectFitLogoType': {
                'id'  : 3,
                'name': 'CERT'
            },
            'displayName'    : 'Players Edge Golf',
            'street'         : '440 BARBARO LANE',
            'city'           : 'Nicholasville',
            'state'          : 'KY',
            'postalCode'     : '40356',
            'countryCode'    : 'US',
            'onWebsite'      : true,
            'active'         : true,
            'latitude'       : 37.947397,
            'longitude'      : -84.6008401,
            'geocodeAccuracy': 'ROOFTOP',
            'events'         : []
        },
        {
            'id'               : 899,
            'businessUnitCode' : 'TM',
            'shiptoId'         : '582593',
            'selectFitLogoType': {
                'id'  : 3,
                'name': 'CERT'
            },
            'displayName'    : 'Green Meadow Country Club',
            'street'         : '6887 NORTH MAYO TRAIL',
            'city'           : 'Pikeville',
            'state'          : 'KY',
            'postalCode'     : '41501',
            'countryCode'    : 'US',
            'onWebsite'      : true,
            'active'         : true,
            'latitude'       : 37.5362789,
            'longitude'      : -82.59849559999999,
            'geocodeAccuracy': 'ROOFTOP',
            'events'         : []
        },
        {
            'id'               : 896,
            'businessUnitCode' : 'TM',
            'shiptoId'         : '555703',
            'selectFitLogoType': {
                'id'  : 3,
                'name': 'CERT'
            },
            'displayName'    : 'Fox Den Country Club',
            'street'         : '12284 N. FOX DEN DR.',
            'city'           : 'Knoxville',
            'state'          : 'TN',
            'postalCode'     : '37922',
            'countryCode'    : 'US',
            'onWebsite'      : true,
            'active'         : true,
            'latitude'       : 35.87407107336646,
            'longitude'      : -84.1903126,
            'geocodeAccuracy': 'ROOFTOP',
            'events'         : []
        },
        {
            'id'               : 895,
            'businessUnitCode' : 'TM',
            'shiptoId'         : '029340',
            'selectFitLogoType': {
                'id'  : 3,
                'name': 'CERT'
            },
            'displayName'    : 'Fairfield Glade',
            'street'         : '103 MAINTENANCE BLVD',
            'city'           : 'Crossville',
            'state'          : 'TN',
            'postalCode'     : '38558',
            'countryCode'    : 'US',
            'onWebsite'      : true,
            'active'         : true,
            'latitude'       : 36.0065236,
            'longitude'      : -84.87458409999999,
            'geocodeAccuracy': 'ROOFTOP',
            'events'         : []
        },
        {
            'id'              : 23,
            'businessUnitCode': 'TM',
            'shiptoId'        : '588548',
            'selectFitEbsCode': {
                'id'  : 1,
                'name': 'PREM'
            },
            'selectFitCategory': {
                'id'  : 2,
                'name': 'PREM'
            },
            'selectFitLogoType': {
                'id'  : 1,
                'name': 'PREM'
            },
            'displayName'    : 'GOLF EXCHANGE DAYTON',
            'street'         : '3647 RIGBY RD.',
            'city'           : 'Miamisburg',
            'state'          : 'OH',
            'postalCode'     : '45342',
            'countryCode'    : 'US',
            'onWebsite'      : true,
            'active'         : true,
            'latitude'       : 39.599425,
            'longitude'      : -84.2325106,
            'geocodeAccuracy': 'ROOFTOP',
            'events'         : []
        },
        {
            'id'               : 746,
            'businessUnitCode' : 'TM',
            'shiptoId'         : '555669',
            'selectFitLogoType': {
                'id'  : 3,
                'name': 'CERT'
            },
            'displayName'    : 'GOLFTEC DAYTON',
            'street'         : '3331 E. STROOP RD.',
            'city'           : 'Dayton',
            'state'          : 'OH',
            'postalCode'     : '45440',
            'countryCode'    : 'US',
            'onWebsite'      : true,
            'active'         : true,
            'latitude'       : 39.6961368,
            'longitude'      : -84.10693739999999,
            'geocodeAccuracy': 'ROOFTOP',
            'events'         : []
        },
        {
            'id'               : 743,
            'businessUnitCode' : 'TM',
            'shiptoId'         : '544064',
            'selectFitLogoType': {
                'id'  : 3,
                'name': 'CERT'
            },
            'displayName'    : 'HARRISON LAKE COUNTRY CLUB',
            'street'         : '588 S COUNTRY CLUB ROAD',
            'city'           : 'Columbus',
            'state'          : 'IN',
            'postalCode'     : '47201',
            'countryCode'    : 'US',
            'onWebsite'      : true,
            'active'         : true,
            'latitude'       : 39.189084,
            'longitude'      : -86.0220106,
            'geocodeAccuracy': 'ROOFTOP',
            'events'         : []
        },
        {
            'id'               : 740,
            'businessUnitCode' : 'TM',
            'shiptoId'         : '584166',
            'selectFitLogoType': {
                'id'  : 3,
                'name': 'CERT'
            },
            'displayName'    : 'TROY COUNTRY CLUB',
            'street'         : '1830 PETERS RD',
            'city'           : 'Troy',
            'state'          : 'OH',
            'postalCode'     : '45373',
            'countryCode'    : 'US',
            'onWebsite'      : true,
            'active'         : true,
            'latitude'       : 40.0157987,
            'longitude'      : -84.2265623,
            'geocodeAccuracy': 'GEOMETRIC_CENTER',
            'events'         : []
        },
        {
            'id'               : 739,
            'businessUnitCode' : 'TM',
            'shiptoId'         : '548678',
            'selectFitLogoType': {
                'id'  : 3,
                'name': 'CERT'
            },
            'displayName'    : 'HEATHERWOODE GOLF COURSE',
            'street'         : '88 HEATHERWOODE BLVD',
            'city'           : 'Springboro',
            'state'          : 'OH',
            'postalCode'     : '45066',
            'countryCode'    : 'US',
            'onWebsite'      : true,
            'active'         : true,
            'latitude'       : 39.5378806,
            'longitude'      : -84.23208059999999,
            'geocodeAccuracy': 'ROOFTOP',
            'events'         : []
        },
        {
            'id'              : 578,
            'businessUnitCode': 'TM',
            'shiptoId'        : '548516',
            'selectFitEbsCode': {
                'id'  : 1,
                'name': 'PREM'
            },
            'selectFitCategory': {
                'id'  : 7,
                'name': 'DICK\'S PREM'
            },
            'selectFitLogoType': {
                'id'  : 1,
                'name': 'PREM'
            },
            'displayName'    : 'DICK\'S SPORTING GOODS',
            'street'         : '2300 GARY FARMS BLVD',
            'city'           : 'Bowling Green',
            'state'          : 'KY',
            'postalCode'     : '42104',
            'countryCode'    : 'US',
            'onWebsite'      : true,
            'active'         : true,
            'latitude'       : 36.95674169999999,
            'longitude'      : -86.43169999999999,
            'geocodeAccuracy': 'GEOMETRIC_CENTER',
            'events'         : []
        },
        {
            'id'              : 554,
            'businessUnitCode': 'TM',
            'shiptoId'        : '521070',
            'selectFitEbsCode': {
                'id'  : 1,
                'name': 'PREM'
            },
            'selectFitCategory': {
                'id'  : 7,
                'name': 'DICK\'S PREM'
            },
            'selectFitLogoType': {
                'id'  : 1,
                'name': 'PREM'
            },
            'displayName'    : 'DICK\'S SPORTING GOODS',
            'street'         : '1336 HANSEL AVENUE',
            'city'           : 'Florence',
            'state'          : 'KY',
            'postalCode'     : '41042',
            'countryCode'    : 'US',
            'onWebsite'      : true,
            'active'         : true,
            'latitude'       : 39.0185446,
            'longitude'      : -84.6376119,
            'geocodeAccuracy': 'ROOFTOP',
            'events'         : []
        },
        {
            'id'              : 550,
            'businessUnitCode': 'TM',
            'shiptoId'        : '555278',
            'selectFitEbsCode': {
                'id'  : 1,
                'name': 'PREM'
            },
            'selectFitCategory': {
                'id'  : 7,
                'name': 'DICK\'S PREM'
            },
            'selectFitLogoType': {
                'id'  : 1,
                'name': 'PREM'
            },
            'displayName'    : 'DICK\'S SPORTING GOODS',
            'street'         : '1 MALL RD UNIT 500',
            'city'           : 'Barboursville',
            'state'          : 'WV',
            'postalCode'     : '25504',
            'countryCode'    : 'US',
            'onWebsite'      : true,
            'active'         : true,
            'latitude'       : 38.4229997,
            'longitude'      : -82.2680049,
            'geocodeAccuracy': 'ROOFTOP',
            'events'         : []
        }
    ]
};